import { render, staticRenderFns } from "./PersonalTariffsPage.vue?vue&type=template&id=3465e6aa&scoped=true&lang=pug&"
import script from "./PersonalTariffsPage.vue?vue&type=script&lang=js&"
export * from "./PersonalTariffsPage.vue?vue&type=script&lang=js&"
import style0 from "./PersonalTariffsPage.vue?vue&type=style&index=0&id=3465e6aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3465e6aa",
  null
  
)

export default component.exports